import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-logo/jb-logo.css.ts
var jb_logo_css_default = i`a{display:block}svg{fill:var(--logo-color, #fff);transition:var(--svg-transition)}path{transition:fill .1s ease;transition-delay:0s}@media(forced-colors: active){svg,svg path{fill:CanvasText}}`;

export {
  jb_logo_css_default
};
